export const PREFERRED_LANGUAGE_STORAGE_KEY = 'preferredLanguage';
export const FRENCH_SUGGESTION_MODAL_SHOWN_STORAGE_KEY =
  'frenchSuggestionModalShown';
export const SUGGESTED_LANGUAGE_COOKIE_NAME = 'suggested-language';
